import { render, staticRenderFns } from "./CmgIngredientsLandingPage.vue?vue&type=template&id=b4be463a&scoped=true&lang=pug&"
import script from "./cmg-ingredients-landing-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-ingredients-landing-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgIngredientsLandingPage.vue?vue&type=style&index=0&id=b4be463a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4be463a",
  null
  
)

export default component.exports